import { MicIcon } from 'assets/icons';
import { ProgressBar } from 'common/progress-bar';
import { AlbumContentType } from 'common/enums';
import { useUploadProgress } from 'hooks/use-upload-progress/use-upload-progress';
import { AlbumUploadEntryProps } from 'context/self-recording-context/context-reducer';
import { selfRecordingActions } from 'context/self-recording-context/action-types';
import { useContext } from 'react';
import { SelfRecordingContext } from 'context/self-recording-context/context';
import { ContentIcons } from 'assets/icons/content-icons';
import styles from './album-upload-entry.module.scss';

const uploadEntries: Record<
  AlbumContentType,
  { icon: React.ReactNode; name: string }
> = {
  [AlbumContentType.video]: {
    icon: ContentIcons.video,
    name: 'Video recording',
  },
  [AlbumContentType.audio]: {
    icon: <MicIcon />,
    name: 'Audio recording',
  },
  [AlbumContentType.document]: {
    icon: ContentIcons.document,
    name: 'Files',
  },
  [AlbumContentType.write]: {
    icon: ContentIcons.journal_entry,
    name: 'Journal entry',
  },
  [AlbumContentType.image]: {
    icon: ContentIcons.image,
    name: 'Image',
  },
};

export const AlbumUploadEntry = ({
  type,
  name,
  data,
  isUploading,
  uploadId,
  onSuccess,
}: AlbumUploadEntryProps & {
  onSuccess: () => void;
}) => {
  const { dispatch } = useContext(SelfRecordingContext);
  const { percentage } = useUploadProgress({
    isUploading,
    onSuccess: () => {
      onSuccess();
      dispatch({
        type: selfRecordingActions.removeUpload,
        removeUpload: uploadId,
      });
    },
  });
  return (
    <div className={styles.container}>
      <div className={styles.icon}>{uploadEntries[type]?.icon}</div>
      <div className={styles.body}>
        <span>Uploading...</span>
        <div className={styles.information}>
          <span>{name || uploadEntries[type]?.name} </span>
          {data && <span>| {data}</span>}
        </div>
        <div className={styles.progress}>
          <div className={styles.progressBar}>
            <ProgressBar
              percentageUsed={percentage}
              reachingLimit={false}
              height={8}
            />
          </div>
          <span>{Math.round((percentage * 100) / 100)}%</span>
        </div>
      </div>
    </div>
  );
};
